import React from "react";
import { withStyles } from "@material-ui/core/styles";
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";

const styles = (theme) => ({
  Table: {
    width: "100%",
  },

  center: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
});
function SelectConfirmation(props) {
  return (
    <Grid container className={props.classes.Table}>
      <FormControl className={props.classes.Table}>
        <InputLabel>Requiere Confirmación</InputLabel>
        <Select
          value={props.ParentState.hasConfirmation}
          onChange={(ev) => {
            props.ParentSet(ev.target.value, "hasConfirmation");
          }}
        >
          <MenuItem value={true} key={1}>
            Con Confirmación
          </MenuItem>
          <MenuItem value={false} key={2}>
            Sin Confirmación
          </MenuItem>
        </Select>
      </FormControl>
    </Grid>
  );
}

export default withStyles(styles)(SelectConfirmation);
